import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-physician-transaction',
  templateUrl: './physician-transaction.component.html',
  styleUrls: ['./physician-transaction.component.css']
})
export class PhysicianTransactionComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
  }

}
